import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'ngx-external-feature-modal',
  templateUrl: './external-feature-modal.component.html',
  styleUrls: ['./external-feature-modal.component.scss']
})
export class ExternalFeatureModalComponent implements OnInit, OnDestroy {

  @Input() url!: string;
  @Input() title = '';

  @Output() closed = new EventEmitter<void>();

  safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    window.addEventListener('message', this.onMessage);
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.onMessage);
  }

  close(): void {
    this.closed.emit();
  }

  private onMessage = (event: MessageEvent): void => {
    if (event.data === 'close') {
      this.close();
    }
  };

}
